import type { Action } from "../state/actions.ts";

interface Props {
  activeEmoji: string | undefined;
  activeEmojiSize: number;
  dispatch: (action: Action) => void;
}

const EMOJIS = [
  "\u2b50",
  "\u2764\ufe0f",
  "\ud83c\udf38",
  "\ud83d\udd4a\ufe0f",
  "\u2709\ufe0f",
  "\ud83c\udf96\ufe0f",
  "\ud83c\udfc5",
  "\ud83c\udf3f",
  "\ud83d\udc90",
  "\ud83d\udd14",
  "\ud83c\udf39",
  "\ud83c\udf1f",
  "\ud83d\udc8c",
  "\ud83c\udf3b",
  "\ud83c\udf1e",
  "\ud83c\udf08",
  "\ud83e\udd8b",
  "\ud83c\udf41",
  "\ud83c\udf40",
  "\u2728",
  "\ud83d\udc95",
  "\ud83c\udf3a",
  "\ud83c\udf37",
  "\ud83c\udf3c",
  "\ud83d\udc1d",
  "\ud83c\udf43",
  "\ud83c\udf42",
  "\u2618\ufe0f",
  "\ud83c\udf4e",
  "\ud83c\udf52",
  "\ud83c\udf53",
  "\ud83e\uddd1\u200d\ud83c\udfa8",
  "\ud83c\udfa8",
  "\ud83c\udfb5",
  "\ud83c\udfb6",
  "\ud83d\udcdd",
  "\ud83d\udce8",
  "\ud83d\udce9",
  "\ud83d\udcee",
  "\ud83d\udcef",
  "\u270f\ufe0f",
  "\ud83d\udd8a\ufe0f",
  "\ud83e\uddf8",
  "\ud83c\udf89",
  "\ud83c\udf8a",
  "\ud83c\udf81",
  "\ud83c\udf80",
  "\ud83d\udc51",
];

export function EmojiPicker({ activeEmoji, activeEmojiSize, dispatch }: Props) {
  return (
    <div
      class="flex flex-col gap-2 p-3 rounded-xl shadow-sm"
      style={{ background: "#F5E6B8", border: "1.5px solid #D4B078" }}
    >
      <div class="grid grid-cols-8 gap-1">
        {EMOJIS.map((emoji) => (
          <button
            key={emoji}
            class="w-8 h-8 text-lg rounded-lg transition-colors"
            style={
              activeEmoji === emoji
                ? { background: "#E8C468", boxShadow: "inset 0 0 0 1.5px #C48A3F" }
                : { background: "transparent" }
            }
            onClick={() => dispatch({ type: "SET_EMOJI", emoji })}
          >
            {emoji}
          </button>
        ))}
      </div>
      <div class="flex items-center gap-2 pt-1" style={{ borderTop: "1px solid #D4B078" }}>
        <span class="text-xs" style={{ color: "#8B7355" }}>
          Size
        </span>
        <input
          type="range"
          min={16}
          max={64}
          value={activeEmojiSize}
          onInput={(e) =>
            dispatch({ type: "SET_EMOJI_SIZE", size: Number((e.target as HTMLInputElement).value) })
          }
          class="w-24"
        />
        <span class="text-xs w-5" style={{ color: "#8B7355" }}>
          {activeEmojiSize}
        </span>
        {activeEmoji && (
          <span class="ml-auto" style={{ fontSize: `${activeEmojiSize}px`, lineHeight: 1 }}>
            {activeEmoji}
          </span>
        )}
      </div>
    </div>
  );
}
